import axios from "axios";
import { useMutation } from "react-query";
import { END_POINT } from "config/environment";

export const deleteContextTip = async (props: {
  token: string;
  id: number | string;
}) => {
  const url = `${END_POINT.BASE_URL}/v1/administrator/context-tips/${props.id}`;
  return axios.delete(url, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  });
};

export const useDeleteContextTip = () => useMutation(deleteContextTip);
